import React, { useEffect, useRef, useState } from "react";

import refoLogo from "../images/logo/iFrameLogo.png";
import { AiOutlineCalculator } from "react-icons/ai";
import {
  TbArrowBigUpLinesFilled,
  TbArrowBigDownLinesFilled,
} from "react-icons/tb";
import {
  Typography,
  Dialog,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  InputLabel,
  TextField,
  FormControl,
  Button,
  MuiThemeProvider,
  InputAdornment,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import jsPDF from "jspdf";
import InterFont from "../fonts/Inter.ttf";
import useStyles from "../themes/style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { customTheme } from "../components/Layout/muiTheme";
import { BsCurrencyRupee } from "react-icons/bs";
import { useLocation, useHistory } from "react-router-dom";
import Notification from "../components/Notification/Notification";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const SalaryBreakTemplate = () => {
  const reportTemplateRef = useRef();
  const classes = useStyles();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const history = useHistory();

  const candidateId = new URLSearchParams(location.search).get("id");

  const [loader, setLoader] = useState(false);
  const [candidateRoleModal, setCandidateRoleModal] = useState(false);
  const [candidateType, setCandidateType] = useState("");
  const [candidateDetails, setCandidateDetails] = useState({
    companyName: "",
    candidateName: "",
    designation: "",
    breakupDate: "",
  });
  const [salaryBreakupData, setSalaryBreakupData] = useState({
    basic: 0,
    hra: 0,
    otherAllowance: 0,
    statutoryBonus: 0,
    shiftAllowance: 0,
    addEmployerPF: 0,
    addESI: 0,
    gratuity: 0,
    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalDeductions: 0,
    totalCTC: 0,
    totalGrossSalary: 0,
  });
  const positions = [toast.POSITION.TOP_RIGHT];
  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const handleCandidateModalClose = () => setCandidateRoleModal(false);
  const handleSelectCandidateType = (role) => setCandidateType(role);

  const styles = {
    masterContainer: {
      minWidth: "800px",
      minHeight: "1000px",
      maxWidth: "800px",
      margin: "auto",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
  };

  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required("Company Name is required"),
    candidateName: Yup.string().required("Candidate Name is required"),
    designation: Yup.string().required("Designation is required"),
    breakupDate: Yup.string().required("Date is required"),
    basic: Yup.number()
      .min(0, "Basic pay must be a number")
      .required("Basic pay is required"),
    otherAllowance: Yup.number()
      .min(0, "Other Allowance must be a number")
      .required("Other Allowance is required"),
    shiftAllowance: Yup.number().when([], {
      is: () => candidateType === "REGULAR",
      then: Yup.number()
        .min(0, "Shift Allowance must be a number")
        .required("Shift Allowance is required"),
      otherwise: Yup.number(),
    }),
    professionalTax: Yup.number()
      .min(0, "Professional Tax must be a number")
      .required("Professional Tax is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      basic: 0,
      otherAllowance: 0,
      shiftAllowance: 0,
      professionalTax: 0,
    },
  });

  function handleAddSalaryBreakupDetailsContract(values) {
    try {
      let HRA = values.basic / 2;
      let stautoryBonus = Math.round(values.basic / 12);

      let totalGrossSalary =
        values.basic + HRA + values.otherAllowance + stautoryBonus;

      let addEmployerPF = Math.round(values.basic * 0.12);
      let totalCTC = totalGrossSalary+addEmployerPF;

      let employeePF = Math.round(values.basic * 0.12);
      let totalDeductions = employeePF + values.professionalTax;

      setSalaryBreakupData({
        basic: values.basic,
        hra: HRA,
        otherAllowance: values.otherAllowance,
        statutoryBonus: stautoryBonus,
        shiftAllowance: 0,
        addEmployerPF: addEmployerPF,
        addESI: 0,
        gratuity: 0,
        employeeESI: 0,
        employeePF: employeePF,
        professionalTax: values.professionalTax,

        totalGrossSalary: totalGrossSalary,
        totalCTC: totalCTC,
        totalDeductions: totalDeductions,
      });
      setCandidateRoleModal(false);
      setCandidateDetails({ ...values });
    } catch (error) {
      console.log(error);
    }
  }

  function handleAddSalaryBreakupDetailsRegular(values) {
    try {
      console.log(values);
      let HRA = values.basic / 2;
      let stautoryBonus = Math.round(values.basic / 12);

      let totalGrossSalary =
        values.basic +
        HRA +
        values.otherAllowance +
        stautoryBonus +
        values.shiftAllowance;

      let addEmployerPF = Math.round(values.basic * 0.12);
      let addESI = Math.round(totalGrossSalary * 0.0325);
      let gratuity = Math.round(values.basic * 0.048);
      let totalCTC = totalGrossSalary+addEmployerPF + addESI + gratuity;

      let employeeESI = Math.round(totalGrossSalary * 0.0075);
      let employeePF = Math.round(values.basic * 0.12);
      let totalDeductions = employeeESI + employeePF + values.professionalTax;

      setSalaryBreakupData({
        basic: values.basic,
        hra: HRA,
        otherAllowance: values.otherAllowance,
        statutoryBonus: stautoryBonus,
        shiftAllowance: values.shiftAllowance,
        addEmployerPF: addEmployerPF,
        addESI: addESI,
        gratuity: gratuity,
        employeeESI: employeeESI,
        employeePF: employeePF,
        professionalTax: values.professionalTax,

        totalGrossSalary: totalGrossSalary,
        totalCTC: totalCTC,
        totalDeductions: totalDeductions,
      });
      setCandidateRoleModal(false);
      setCandidateDetails({ ...values });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (candidateId) {
      setCandidateRoleModal(true);
    }
  }, []);

  async function handleAgreementSign(pdfBlob, doc) {
    setLoader(true);
    const formData = new FormData();
    const nonDisclosureFile = new File(
      [pdfBlob],
      `salary-break-up_${Date.now()}.pdf`,
    );
    formData.append("document", nonDisclosureFile);
    formData.append("sendMessage", false);
    formData.append("candidateId", candidateId);
    formData.append("phone_number", "8870762077");
    formData.append("template_name", "salary_breakup_shared_confirmation");
    formData.append("message", "message");

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/changeAndSendOfferDetail`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        handleNotificationCall("success", response.data.message);
        doc.save(`salary-break-up_${candidateId}_${Date.now()}.pdf`);
        if (decode.role === "ADMIN") {
          history.push("/app/admin_candidates");
        } else {
          history.push("/app/dashboard");
        }
      } else {
        setLoader(false);
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  const handleGeneratePdf = async () => {
    if (!token || !candidateId) {
      handleNotificationCall("info", "permission denied");
      return;
    }
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = reportTemplateRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          handleAgreementSign(pdfBlob, doc);
          // doc.save(`non-disclosure_agreement${Date.now()}.pdf`);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  const handleCancelSendBreakup = () => {
    setCandidateRoleModal(true);
    window.history.go(-1);
  };

  return (
    <MuiThemeProvider theme={customTheme}>
      <div style={{ padding: "20px" }}>
        <div ref={reportTemplateRef} style={styles.masterContainer}>
          <table style={{ fontSize: "12px", lineHeight: "20px" }}>
            <thead>
              <tr>
                <td colSpan={2} style={{ padding: "0 16px 0px 16px" }}>
                  <table
                    style={{
                      borderBottom: "1px solid #D7DAE0",
                      width: "100%",
                      fontSize: "12px",
                      lineHeight: "20px",
                      tableLayout: "fixed",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <h1
                            style={{
                              color: "#1A1C21",
                              fontSize: "22px",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "normal",
                              textAlign: "start",
                              margin: "8px 0px",
                            }}
                          >
                            {candidateDetails.companyName}
                          </h1>
                        </td>
                        <td style={{ padding: "0 16px 0px 16px" }}>
                          <div
                            style={{
                              color: "#1A1C21",
                              fontSize: "22px",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "normal",
                              textAlign: "end",
                              margin: "8px 0px",
                            }}
                          >
                            <img
                              src={refoLogo}
                              style={{ width: "90px" }}
                              width="100%"
                              alt="refo-logo"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{ padding: "0 16px 0px 16px" }}>
                  <table
                    style={{
                      borderBottom: "1px solid #D7DAE0",
                      width: "100%",
                      fontSize: "12px",
                      lineHeight: "20px",
                      tableLayout: "fixed",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td colSpan="2">
                          <h1
                            style={{
                              color: "#1A1C21",
                              fontSize: "16px",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "normal",
                              textAlign: "center",
                              margin: "8px 0px",
                            }}
                          >
                            Salary Breakup
                          </h1>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "end",
                    paddingBottom: "12px",
                    paddingTop: "12px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    verticalAlign: 0,
                  }}
                >
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "35%",
                      textAlign: "left",
                    }}
                  >
                    <tbody>
                      <tr style={{ paddingTop: "12px" }}>
                        <th
                          style={{
                            textAlign: "left",
                            color: "#1A1C21",
                          }}
                        >
                          Name
                        </th>
                        <td>{candidateDetails.candidateName}</td>
                      </tr>
                      <tr>
                        <th
                          style={{
                            textAlign: "left",
                            color: "#1A1C21",
                          }}
                        >
                          Designation
                        </th>
                        <td>{candidateDetails.designation}</td>
                      </tr>
                      <tr>
                        <th
                          style={{
                            textAlign: "left",
                            color: "#1A1C21",
                          }}
                        >
                          Date
                        </th>
                        <td>{candidateDetails.breakupDate}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          textAlign: "end",
                          paddingBottom: "12px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          verticalAlign: 0,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "rgb(82 216 146 / 34%)",
                            borderRadius: "6px",
                            borderWidth: "0",

                            color: "#fff",
                            cursor: "pointer",
                            fontFamily:
                              '-apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif',
                            lineHeight: "1.15",
                            outline: "none",
                            overflow: "hidden",
                            padding: "5px 25px",
                            textAlign: "center",
                            textTransform: "none",
                            transform: "translateZ(0)",
                            transition: "all .2s,box-shadow .08s ease-in",
                            width: "100%",
                          }}
                          role="button"
                        >
                          <TbArrowBigUpLinesFilled
                            size={24}
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 15,
                              margin: "auto 0",
                            }}
                          />
                          <span>
                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#21704b",
                                display: "block",
                              }}
                            >
                              {salaryBreakupData.totalGrossSalary}
                            </span>
                            <span style={{ color: "#21704b" }}>
                              Gross Salary
                            </span>
                          </span>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "end",
                          paddingBottom: "12px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          verticalAlign: 0,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "rgb(255 184 184)",
                            borderRadius: "6px",
                            borderWidth: "0",

                            color: "#fff",
                            cursor: "pointer",
                            fontFamily:
                              '-apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif',
                            fontSize: "100%",
                            lineHeight: "1.15",
                            outline: "none",
                            overflow: "hidden",
                            padding: "5px 25px",
                            textAlign: "center",
                            textTransform: "none",
                            transform: "translateZ(0)",
                            transition: "all .2s,box-shadow .08s ease-in",
                            width: "100%",

                            gap: "2px",
                          }}
                          role="button"
                        >
                          <TbArrowBigDownLinesFilled
                            size={24}
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 15,
                              margin: "auto 0",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: 700,
                              color: "#852929",
                              display: "block",
                            }}
                          >
                            {salaryBreakupData.totalDeductions}
                          </span>
                          <span style={{ color: "#852929" }}>Deductions</span>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "end",
                          paddingBottom: "12px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          verticalAlign: 0,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "rgb(190 214 255)",
                            borderRadius: "6px",
                            borderWidth: "0",

                            color: "#fff",
                            cursor: "pointer",
                            fontFamily:
                              '-apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif',
                            fontSize: "100%",
                            lineHeight: "1.15",
                            outline: "none",
                            overflow: "hidden",
                            padding: "5px 25px",
                            textAlign: "center",
                            textTransform: "none",
                            transform: "translateZ(0)",
                            transition: "all .2s,box-shadow .08s ease-in",
                            width: "100%",
                          }}
                          role="button"
                        >
                          <AiOutlineCalculator
                            size={24}
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 15,
                              margin: "auto 0",
                            }}
                            color="#2e4472"
                          />
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: 700,
                              color: "#2e4472",
                              display: "block",
                            }}
                          >
                            {salaryBreakupData.totalGrossSalary -
                              salaryBreakupData.totalDeductions}
                          </span>
                          <span style={{ color: "#2e4472" }}>Net Salary</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </tr>
              <tr>
                <td colSpan="2" style={{ padding: "0px 16px" }}>
                  <table
                    style={{
                      backgroundColor: "#FFF",
                      padding: "20px 16px",
                      border: "1px solid #D7DAE0",
                      width: "100%",
                      borderRadius: "4px",
                      fontSize: "12px",
                      lineHeight: "20px",
                      tableLayout: "fixed",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          <table
                            style={{
                              width: "100%",
                              borderSpacing: 0,
                            }}
                          >
                            <thead>
                              <tr style={{ textTransform: "uppercase" }}>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    fontSize: "12px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Gross Salary
                                </td>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per month
                                </td>

                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per annum
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>Basic</td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.basic}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.basic * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>HRA</td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.hra}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.hra * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Other Allowance
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.otherAllowance}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.otherAllowance * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Statutory Bonus
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.statutoryBonus}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.statutoryBonus * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Shift Allowance
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.shiftAllowance}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.shiftAllowance * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}></td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={3}
                                  style={{ verticalAlign: "top" }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderSpacing: 0,
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td style={{ paddingBlock: "12px" }}>
                                          Total
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalGrossSalary}
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalGrossSalary *
                                            12}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="2" style={{ padding: "24px 16px 0px" }}>
                  <table
                    style={{
                      backgroundColor: "#FFF",
                      padding: "20px 16px",
                      border: "1px solid #D7DAE0",
                      width: "100%",
                      borderRadius: "4px",
                      fontSize: "12px",
                      lineHeight: "20px",
                      tableLayout: "fixed",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{ verticalAlign: "top", paddingRight: "15px" }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderSpacing: 0,
                              paddingLeft: "10px",
                            }}
                          >
                            <thead>
                              <tr style={{ textTransform: "uppercase" }}>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    fontSize: "12px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Cost-to-Company (CTC)
                                </td>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per month
                                </td>

                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per annum
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Total Gross Salary
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.totalGrossSalary}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.totalGrossSalary * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Add : Employer PF @ 12% on basic
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.addEmployerPF}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.addEmployerPF * 12}
                                </td>
                              </tr>
                              {candidateType === "REGULAR" && (
                                <>
                                  <tr>
                                    <td style={{ paddingBlock: "12px" }}>
                                      Add : ESI @ 3.25% on Gross
                                    </td>
                                    <td
                                      style={{
                                        paddingBlock: "12px",
                                        textAlign: "end",
                                      }}
                                    >
                                      {salaryBreakupData.addESI}
                                    </td>
                                    <td
                                      style={{
                                        paddingBlock: "12px",
                                        textAlign: "end",
                                      }}
                                    >
                                      {salaryBreakupData.addESI * 12}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ paddingBlock: "12px" }}>
                                      Gratuity @ 4.8% on Basic **
                                    </td>
                                    <td
                                      style={{
                                        paddingBlock: "12px",
                                        textAlign: "end",
                                      }}
                                    >
                                      {salaryBreakupData.gratuity}
                                    </td>
                                    <td
                                      style={{
                                        paddingBlock: "12px",
                                        textAlign: "end",
                                      }}
                                    >
                                      {salaryBreakupData.gratuity * 12}
                                    </td>
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td style={{ paddingBlock: "12px" }}></td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={3}
                                  style={{ verticalAlign: "top" }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderSpacing: 0,
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td style={{ paddingBlock: "12px" }}>
                                          Total
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalCTC}
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalCTC * 12}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{ verticalAlign: "top", paddingLeft: "15px" }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderSpacing: 0,
                              paddingRight: "10px",
                            }}
                          >
                            <thead>
                              <tr style={{ textTransform: "uppercase" }}>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    fontSize: "12px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Deductions
                                </td>
                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per month
                                </td>

                                <td
                                  style={{
                                    padding: "8px 0",
                                    borderBottom: "1px solid #D7DAE0",
                                    textAlign: "end",
                                    width: "80px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Per annum
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {candidateType === "REGULAR" && (
                                <tr>
                                  <td style={{ paddingBlock: "12px" }}>
                                    Employee ESI @ 0.75% on Gross
                                  </td>
                                  <td
                                    style={{
                                      paddingBlock: "12px",
                                      textAlign: "end",
                                    }}
                                  >
                                    {salaryBreakupData.employeeESI}
                                  </td>
                                  <td
                                    style={{
                                      paddingBlock: "12px",
                                      textAlign: "end",
                                    }}
                                  >
                                    {salaryBreakupData.employeeESI * 12}
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Employee PF @ 12% on basic
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.employeePF}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.employeePF * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                  Professional Tax
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.professionalTax}
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                >
                                  {salaryBreakupData.professionalTax * 12}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ paddingBlock: "12px" }}>
                                <p style={{height:"20px"}}></p>
                                </td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                                <td
                                  style={{
                                    paddingBlock: "12px",
                                    textAlign: "end",
                                  }}
                                ></td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={3}
                                  style={{ verticalAlign: "top" }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderSpacing: 0,
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td style={{ paddingBlock: "12px" }}>
                                          Total
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalDeductions}
                                        </td>
                                        <td
                                          style={{
                                            paddingBlock: "12px",
                                            textAlign: "end",
                                            width: "80px",
                                          }}
                                        >
                                          {salaryBreakupData.totalDeductions *
                                            12}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "end", padding: "16px 16px 8px 16px" }}>
                  <span>Net Salary: </span>₹{" "}
                  {salaryBreakupData.totalGrossSalary -
                    salaryBreakupData.totalDeductions}
                  /per annum
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={classes.flexCenter} style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            size="small"
            color="default"
            onClick={handleCancelSendBreakup}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            color="success"
            className={classes.green}
            onClick={handleGeneratePdf}
          >
            Send this Salary Break up to Candidate
          </Button>
        </div>

        <Dialog
          aria-labelledby="dialog-title"
          open={candidateRoleModal}
          maxWidth="xs"
          PaperProps={{
            style: {
              width: "100%",
            },
          }}
        >
          {candidateType === "REGULAR" ? (
            <>
              <h2
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  padding: "10px 20px",
                  margin: "4px 0px",
                }}
              >
                Salary Breakup
              </h2>
              <form
                onSubmit={handleSubmit(handleAddSalaryBreakupDetailsRegular)}
              >
                <DialogContent dividers>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="companyName">
                        Company Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Company Name"
                          {...register("companyName")}
                          error={errors.companyName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.companyName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="candidateName">
                        Candidate Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Candidate Name"
                          {...register("candidateName")}
                          error={errors.candidateName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.candidateName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="designation">
                        Designation
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Designation Name"
                          {...register("designation")}
                          error={errors.designation ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.designation?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="breakupDate">
                        Date
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="date"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Date"
                          {...register("breakupDate")}
                          error={errors.breakupDate ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.breakupDate?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="basic">
                        Basic pay per month
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="end">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Basic Pay"
                          {...register("basic")}
                          error={errors.basic ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.basic?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="otherAllowance">
                        Other Allowance per month
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Other Allowance"
                          {...register("otherAllowance")}
                          error={errors.otherAllowance ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.otherAllowance?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="shiftAllowance">
                        Shift Allowance per month
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Shift Allowance"
                          {...register("shiftAllowance")}
                          error={errors.shiftAllowance ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.shiftAllowance?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="professionalTax">
                        Professional Tax
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="end">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Professional Tax"
                          {...register("professionalTax")}
                          error={errors.professionalTax ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.professionalTax?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="small"
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </DialogContent>
              </form>
            </>
          ) : candidateType === "CONTRACT" ? (
            <>
              <h2
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  padding: "10px 20px",
                  margin: "4px 0px",
                }}
              >
                Salary Breakup
              </h2>
              <form
                onSubmit={handleSubmit(handleAddSalaryBreakupDetailsContract)}
              >
                <DialogContent dividers>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="companyName">
                        Company Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Company Name"
                          {...register("companyName")}
                          error={errors.companyName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.companyName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="candidateName">
                        Candidate Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Candidate Name"
                          {...register("candidateName")}
                          error={errors.candidateName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.candidateName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="designation">
                        Designation
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Designation Name"
                          {...register("designation")}
                          error={errors.designation ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.designation?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="breakupDate">
                        Date
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="date"
                          InputProps={{ disableUnderline: true }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Date"
                          {...register("breakupDate")}
                          error={errors.breakupDate ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.breakupDate?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="basic">
                        Basic pay per month
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="end">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Basic Pay"
                          {...register("basic")}
                          error={errors.basic ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.basic?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="otherAllowance">
                        Other Allowance per month
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Other Allowance"
                          {...register("otherAllowance")}
                          error={errors.otherAllowance ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.otherAllowance?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={6}>
                      <InputLabel shrink htmlFor="professionalTax">
                        Professional Tax
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="end">
                                <BsCurrencyRupee />
                              </InputAdornment>
                            ),
                          }}
                          classes={{ root: classes.customTextField }}
                          placeholder="Enter Professional Tax"
                          {...register("professionalTax")}
                          error={errors.professionalTax ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.professionalTax?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="small"
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </DialogContent>
              </form>
            </>
          ) : (
            <>
              <h2
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  padding: "10px 20px",
                  margin: "0px",
                }}
              >
                Candidate Type
              </h2>
              <List
                style={{
                  padding: "0px 10px 10px 10px",
                  marginBottom: "10px  ",
                }}
              >
                <ListItem
                  autoFocus
                  button
                  onClick={() => handleSelectCandidateType("REGULAR")}
                >
                  <ListItemText primary="Regular Candidate" />
                </ListItem>
                <ListItem
                  button
                  onClick={() => handleSelectCandidateType("CONTRACT")}
                >
                  <ListItemText primary="Contract Candidate" />
                </ListItem>
              </List>
            </>
          )}
        </Dialog>
        <ToastContainer
          closeButton={
            <CloseButton className={classes.notificationCloseButton} />
          }
          closeOnClick={false}
          hideProgressBar={true}
        />
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </MuiThemeProvider>
  );
};

export default SalaryBreakTemplate;

function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
